module.exports = __webpack_public_path__ + "static/img/slogan.efc75d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/en/slogan.png
// module id = mvGP
// module chunks = 0